import { Modal } from "react-bootstrap";
import { Button } from "../button";
import { GenericForm } from "../generic-form";

import { RequestDigitalSignatureModalProps } from "./RequestDigitalSignatureModal.types";

export const RequestDigitalSignatureModal = ({
  isVisible,
  onDismiss,
  onSubmit,
  creating,
  requestDigitalSignatureForm,
}: RequestDigitalSignatureModalProps) => {
  return (
    <Modal show={isVisible} animation onHide={onDismiss}>
      <Modal.Header>
        <h5 className="modal-title" id="Dismiss Modal">
          Request Digital Signature
        </h5>
        <div onClick={onDismiss}>
          <span className="font-20 cursor-pointer">&times;</span>
        </div>
      </Modal.Header>
      <Modal.Body>
        <GenericForm
          form={requestDigitalSignatureForm}
          onSubmit={onSubmit}
          submitControl={(submit) => (
            <div className="flex-row">
              <Button
                isLoading={creating}
                loader={{ size: "s" }}
                className="btn btn-primary mt-3 w-100"
                type="submit"
              >
                Request
              </Button>
            </div>
          )}
        />
      </Modal.Body>
    </Modal>
  );
};
